import { generatePath } from 'react-router-dom';
import clientRoute from '../clientRoute';

export const getTaskRoute = (id: string, taskTypeCode?: string): string => {
    return generatePath(clientRoute.expertiseTask, { id });
};
